/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI
 * Copyright IBM Corp. 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

define([
	'react',
	'prop-types'
], (React, PropTypes) => {

	return class SectionTitle extends React.Component {

		static propTypes = {
			name: PropTypes.string.isRequired,
			label: PropTypes.string.isRequired
		};

		render() {
			return (
				<div className={`carbonPropertyRow sectionTitle capp_${this.props.name}`}>
					<div tabIndex="0" className="propsLabel" ariaLabel={this.props.label}>{this.props.label}</div>
				</div>
			);
		}
	};

});